// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const raw = import.meta.env.VITE_FIREBASE_CONFIG;
const cleaned = raw?.trim().replace(/^'+|'+$/g, ''); // remove leading/trailing single quotes

let firebaseConfig;
const fallbackConfig = {
  apiKey: 'dev-api-key',
  authDomain: 'dev-auth-domain',
  projectId: 'innex-local',
  storageBucket: 'dev-storage-bucket',
  messagingSenderId: 'dev-sender-id',
  appId: 'dev-app-id'
};

try {
  firebaseConfig = JSON.parse(cleaned || '{}');
} catch (e) {
  if (import.meta.env.DEV) {
    console.warn('Failed to parse VITE_FIREBASE_CONFIG, using dummy config for development');
    firebaseConfig = fallbackConfig;
  } else {
    console.error('Failed to parse VITE_FIREBASE_CONFIG in production');
    throw e;
  }
}

// Ensure minimal config for development if parsing yielded an empty or incomplete object
if (import.meta.env.DEV && (!firebaseConfig || !firebaseConfig.apiKey)) {
  firebaseConfig = fallbackConfig;
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

if (import.meta.env.DEV) {
  connectAuthEmulator(auth, 'http://localhost:9099');
}

export { auth };
